import { Layout as LayoutAnt } from 'antd';
import PropTypes from 'prop-types';
import { StyleLayout } from './style';

function Layout(props) {
  const { children } = props;
  return (
    <StyleLayout>
      <LayoutAnt>{children}</LayoutAnt>
    </StyleLayout>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
